import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom"
import { WidgetHasMeasures } from "../Widgets/WidgetHasMeasures";
import { LanguageString } from "../../../Model/LanguageString";
import { DynPopup } from "../../../Components/DynPopup";
import { TextComponent } from "../../../Components/TextComponent";
import { app } from "../../../Frame/App";
import { ListItem } from "../../../Model/ListItem";
import { ListView } from "../../../Components/ListView/ListView";
import { LanguageStringComponent } from "../../../Components/LanguageStringComponent";
import { CheckboxCompoment } from "../../../Components/CheckboxComponent";

export type PopupHasMeasuresComponentProps = {
    widget: WidgetHasMeasures;
}

export class PopupHasMeasuresComponent extends JSXComponent {
    props: PopupHasMeasuresComponentProps;
    textAny: string;
    textNone: string;
    iconCssClass: string;
    templateIds: number[];
    title: LanguageString;
    additionalFilter: string;
    rowClickUrl: string;
    rowClickUrlUsePopup: boolean;

    templates: ListView;

    constructor(props: PopupHasMeasuresComponentProps) {
        super(props);

        this.title = this.props.widget.props.title;
        this.textAny = this.props.widget.props.textAny;
        this.textNone = this.props.widget.props.textNone;
        this.iconCssClass = this.props.widget.props.iconCssClass;
        this.templateIds = this.props.widget.props.templateIds;
        this.additionalFilter = this.props.widget.props.additionalFilter;
        this.rowClickUrl = this.props.widget.props.rowClickUrl;
        this.rowClickUrlUsePopup = this.props.widget.props.rowClickUrlUsePopup;

        if (!this.title) this.title = new LanguageString();
        if (!this.templateIds) this.templateIds = [];
    }

    onSave = (): boolean => {
        this.props.widget.props.textAny = this.textAny;
        this.props.widget.props.textNone = this.textNone;
        this.props.widget.props.iconCssClass = this.iconCssClass;
        this.props.widget.props.templateIds = this.templates.getSelectedIds();
        this.props.widget.props.title = this.title;
        this.props.widget.props.additionalFilter = this.additionalFilter;
        this.props.widget.props.rowClickUrl = this.rowClickUrl;
        this.props.widget.props.rowClickUrlUsePopup = this.rowClickUrlUsePopup;

        this.props.widget.recreate();
        return true;
    }

    element: HTMLElement;
    getElement = (): HTMLElement => {
        return <DynPopup size="fit" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
            title={Resources['WidgetClient'].widgetHasMeasures}>

            <LanguageStringComponent model={this.title} name={Resources["WidgetClient"].title} showLabel={true} />

            <div className="mb-3 template-selection">
                {this.renderTemplates()}
            </div>

            <TextComponent model={this} field="textAny" name={Resources["WidgetClient"].hasMeasuresTextAny} textarea={true} />
            <TextComponent model={this} field="textNone" name={Resources["WidgetClient"].hasMeasuresTextNone} textarea={true} />
            <TextComponent model={this} field="iconCssClass" name={Resources["WidgetClient"].hasMeasuresIconCssClass} />
            <TextComponent model={this} field="additionalFilter" name={Resources["WidgetClient"].hasMeasuresAdditionalFilter} />
            <div className="info mb-3">
                Format: @FELD;OPERATOR;VALUE;null;LINK
            </div>

            <TextComponent model={this} field="rowClickUrl" name="URL bei Klick auf eine Zeile aufrufen" createFormGroup={true} />
            <CheckboxCompoment
                model={this}
                field="rowClickUrlUsePopup"
                label="Popup verwenden"
                additionalCssClasses="col-md-5"
                createFormGroup={true}
            />

        </DynPopup >;
    }

    renderTemplates = (): HTMLElement => {
        let div: HTMLElement = <div></div>;

        $.ajax({
            url: app.resolveUrl("~/api/measure/getTemplates"),
            method: "GET",
            success: (items: ListItem[]) => {
                this.templates = new ListView({
                    name: Resources['WidgetClient'].templates,
                    displayProperty: "name",
                    idProperty: "id",
                    checkedProperty: "checked",
                    model: items,
                    allowSelect: true,
                    selectedIds: this.templateIds
                });

                let parent = this.element.querySelector(".template-selection") as HTMLElement;
                parent.appendChild(this.templates.render());
                app.destroyDomElements(div);
            },
            error: (err) => {
                console.log(err);
            }
        })
        return div;
    }

    render(): HTMLElement {
        this.element = this.getElement();
        return this.element;
    }
}